<template>
  <footer class="footer bg-dark text-light py-3 text-center bottom">
    <div class="container">
      <span class="fw-semibold">
        Powered by <span class="text-primary">Mysoft Code</span> © {{ currentYear }}
      </span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
.footer {
  margin-bottom: 0; /* ensures no extra space */
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
}
</style>
